// @flow
export { default } from './Image';



// WEBPACK FOOTER //
// ./src/components/base/Image/index.js